import DereferenceError from "./DereferenceError.mjs";
/**
 * @public
 */
class UnmatchedDereferenceStrategyError extends DereferenceError {}
export default UnmatchedDereferenceStrategyError;